module.exports = __webpack_public_path__ + "static/media/logo-blue-circle.c496a0e5.png";